import React, { useMemo } from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import DatePickerRoot from '../../../common/DatePickerCustom/root';
import { useToggleFlag } from '../../../../hocs/useToogleFlag';
import LocationPicker from '../../Components/LocationPicker';
import Button from '../../../Button';
import Icon from '../../../Icon';
import {
  formatToDate,
  getISOString,
  getMinDate,
  humanizeDate,
} from '../../../../utils/appointments/dateFilter';
import styles from './styles.styl';

const minDate = getMinDate().toDate();

function ScheduleFilter({
  activeDate,
  activeLocations,
  disabled,
  filterList,
  formatMessage,
  isEirVisitType,
  isVirtualVisit,
  onDateChange,
  onLocationFilterApply,
  styles: _styles,
}) {
  const formattedDate = useMemo(() => formatToDate(activeDate), [activeDate]);
  const displayableDate = useMemo(() => humanizeDate(activeDate), [activeDate]);
  const [dateOpened, openDateModal, closeDateModal] = useToggleFlag();

  const handleDateChange = newDate => {
    const date = getISOString(newDate);
    onDateChange(date);
    closeDateModal();
  };

  return (
    <div styleName={cn('root', { disabled })}>
      <DatePickerRoot
        inputClassName={_styles.DateFilterInput}
        active={dateOpened}
        onChange={handleDateChange}
        value={formattedDate}
        minDate={minDate}
        sundayFirstDayOfWeek
        onDismiss={closeDateModal}
      />
      {!isEirVisitType && (
        <Button
          styleName="DateFilter"
          onClick={openDateModal}
          color="accent"
          border
        >
          <Icon name="calendar" />
          {displayableDate}
        </Button>
      )}
      <LocationPicker
        isVirtualVisit={isVirtualVisit}
        formatMessage={formatMessage}
        onApply={onLocationFilterApply}
        activeLocations={activeLocations}
        filterList={filterList}
      />
    </div>
  );
}

ScheduleFilter.propTypes = {
  activeDate: PropTypes.string,
  activeLocations: PropTypes.array,
  disabled: PropTypes.bool,
  filterList: PropTypes.array,
  formatMessage: PropTypes.func,
  isEirVisitType: PropTypes.bool,
  isVirtualVisit: PropTypes.bool,
  onDateChange: PropTypes.func,
  onLocationFilterApply: PropTypes.func,
  styles: PropTypes.object,
};

export default CSSModules(ScheduleFilter, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviders/ScheduleFilter/index.jsx